// import media files
import EducationWebinar1 from 'assets/images/education/edu-webinar-1.jpg';
import EducationWebinar2 from 'assets/images/education/edu-webinar-2.jpg';
import EducationWebinar3 from 'assets/images/education/edu-webinar-3.jpg';

export const UpcomingWebinarsData = [
	{
		id: 1,
		image: EducationWebinar1,
		title: 'Education Edition Deployment And Set Up',
		date: 'Thu, November 10, 2023',
		time: '6:00 PM – 8:00 PM GMT'
	},
	{
		id: 2,
		image: EducationWebinar2,
		title: 'Build a Collaborative Classroom',
		date: 'June 26, 2023',
		time: '8:00 AM PDT'
	},
	{
		id: 3,
		image: EducationWebinar3,
		title: 'Increase Reading And Language Skill',
		date: 'November 10, 2023',
		time: '10:00 PM IST'
	}
];

export default UpcomingWebinarsData;
